
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a-propos",
      function () {
        return require("private-next-pages/a-propos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/a-propos"])
      });
    }
  